import React from "react";
import { Link } from "react-router-dom";
import { BrandLogo } from "@/components/BrandLogo";

export const Footer = () => (
  <footer className="lr-gradient-dark text-slate-300 mt-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="inline-block rounded-2xl bg-white p-3" data-testid="footer-logo">
            <BrandLogo variant="full" className="h-20" />
          </div>
          <p className="mt-4 text-sm leading-relaxed text-slate-400">
            La plateforme qui aide les loueurs indépendants à commercialiser et gérer leur flotte, et les clients à comparer et réserver facilement. Premier lancement au Maroc 🇲🇦.
          </p>
        </div>
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-slate-500 mb-4">Clients</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/cars" className="hover:text-white">Rechercher un véhicule</Link></li>
            <li><Link to="/agencies" className="hover:text-white">Nos agences partenaires</Link></li>
            <li><Link to="/compare" className="hover:text-white">Comparer les véhicules</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-slate-500 mb-4">Loueurs</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/register" className="hover:text-white">Publier mon agence</Link></li>
            <li><Link to="/login" className="hover:text-white">Espace loueur</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-slate-500 mb-4">Villes</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li>Casablanca · Marrakech</li>
            <li>Rabat · Tanger · Agadir</li>
            <li>Fès · Oujda · Dakhla</li>
          </ul>
        </div>
      </div>
      <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-slate-500">
        <p>© 2026 link&rent — Vous avez les voitures. Nous trouvons les clients.</p>
        <div className="flex gap-2">
          <span className="h-3 w-5 rounded-sm" style={{ background: "#C1272D" }} />
          <span className="h-3 w-5 rounded-sm" style={{ background: "#006233" }} />
        </div>
      </div>
    </div>
  </footer>
);
